import React, { useRef, useState } from "react";
import { Grid, Button, Typography, } from '@material-ui/core';
import { useForm } from "../../../hooks/useForm";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import BuscadorPractica from "./BuscadorPractica";

export const EquivalenciasNomencladoresForm = ({ formData, editable, handleSubmit, handleCancel }) => {

  const buscadorRef = useRef(null);
  const [codigoPractica, setCodigoPractica] = useState(null)

  const datosNuevaPractica = {
    codigoOspedyc: "",
    codigoPrestador: "",
    descripcion: "",
  }

  const [
    formValues,
    handleInputChange,
    ,
    setearValor
  ] = useForm(formData !== null ? formData : datosNuevaPractica);

  const onSubmit = (e) => {
    e.preventDefault()
    if (editable) {
        handleSubmit({ ...formValues,  })
    }
  }
  return (
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container spacing={2}>
      <Grid item xs={12}>
          <BuscadorPractica ref={buscadorRef} cod={codigoPractica} label="Buscador de practica de Ospedyc" fieldsDisabled={false} setCod={(val) => { setCodigoPractica(val); setearValor("codigoOspedyc", val.codNomPlano) }} />
        </Grid>
        <Grid item xs={12}>
        <Typography variant="overline" style={{fontWeight:"bold"}}>DATOS</Typography>

          <TextValidator
            fullWidth
            label="Código Ospedyc"
            name="codigoOspedyc"
            value={formValues.codigoOspedyc}
            // onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["El codigo de ospedyc es requerido"]}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextValidator
            fullWidth
            label="Código Prestador"
            autoComplete="off"
            name="codigoPrestador"
            value={formValues.codigoPrestador}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["El codigo del prestador es requerido"]}
          />
        </Grid>
        <Grid item xs={12}>
          <TextValidator
            fullWidth
            label="Descripcion"
            autoComplete="off"
            name="descripcion"
            value={formValues.descripcion}
            onChange={handleInputChange}
            validators={["required", "maxStringLength:50"]}
            errorMessages={["La descripcion es requerida", "Puede tener hasta 50 caracteres"]}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} justify="flex-end">
        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            CANCELAR
          </Button>
        </Grid>
        {
          (editable && !formValues.fecBaja) &&

          <Grid item>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SaveIcon />}
              type='submit'
            >
              GUARDAR
            </Button>
          </Grid>
        }
      </Grid>
    </ValidatorForm>
  );
};
